export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';
export const LOGIN_USER = 'LOGIN_USER';
